import { render, staticRenderFns } from "./TaskManagement.vue?vue&type=template&id=0c07f725&scoped=true"
import script from "./TaskManagement.vue?vue&type=script&lang=js"
export * from "./TaskManagement.vue?vue&type=script&lang=js"
import style0 from "./TaskManagement.vue?vue&type=style&index=0&id=0c07f725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07f725",
  null
  
)

export default component.exports